import { supabase } from "../supabaseClient";

async function FetchAllUserFromServer(
  projectId,
  startDate,
  endDate,
  teamIds,
  id,
  projectIds
) {
  let query = supabase
    .from("AllotmentPayment")
    .select(
      "* ,unitId(*,wingId(wingName),inventoryTypeId(*),projectId(projectId,projectName)),leadId(*,userId(*),personId(*))"
    )
    .not("status" , 'ilike' , '%Refund%')
    .not("status" , 'ilike' , '%Cancel%')
    .not("status" , 'ilike' , '%cancel%')
    .not("status" , 'ilike' , '%Released%')
    .in("leadId.userId", teamIds);


  const idArr = id?.map((el) => {
    return el?.id;
  });


  if (id && idArr.length > 0 && id !== "All" && id !== "" && id !== "null") {
    query = query.in("unitId.projectId.projectId", [...idArr]);
  } else if(id  && id !== "All" && id !== "" && id !== "null") {
    query = query.in("unitId.projectId.projectId", projectIds);
  }
  // if (id && id?.length > 0 && id !== "All" && id !== "" ) {
  //   query = query.in("unitId.projectId.projectId", [id]);
  // }

  if (
    startDate !== "" &&
    endDate !== "" &&
    startDate !== null &&
    endDate !== null &&
    startDate &&
    endDate &&
    (startDate !== "0" || endDate !== "0")
  ) {
    if (startDate === "0") {
      query = query.lte("created_at", endDate);
    } else if (endDate === "0") {
      query = query.gte("created_at", startDate);
    } else if (startDate !== "0" && endDate !== "0") {
      query = query.gte("created_at", startDate).lte("created_at", endDate);
    }
  }

  const { data, error } = await query;

  if (data) return data;
  else throw error;
}

async function FetchTokenPaymentData(
  teamIds,
  id,
  startDate,
  endDate,
  launchId
) {

  let query = supabase
    .from("EventTokenLeadRelations")
    .select(
      "status,launchId(title, launchId), leadId(leadDisplayId,personId(name), userId(name)), eventId(eventId, title),eventTokenId(prerequisiteId(tokenId(tokenId, name)),tokenId(tokenId, name, isPriorityPass, isPreselect))"
    );
  if (teamIds) {
    query.in("leadId.userId.userId", teamIds);
  }

  if (id && id !== "All" && id !== "") {
    query = query.eq("eventId.eventId", id);
  }

  if (launchId && launchId !== "All") {
    query = query.eq("launchId.launchId", launchId);
  }

  if (
    startDate !== "" &&
    endDate !== "" &&
    startDate !== null &&
    endDate !== null &&
    startDate &&
    endDate &&
    (startDate !== "0" || endDate !== "0")
  ) {
    if (startDate === "0") {
      query = query.lte("created_at", endDate);
    } else if (endDate === "0") {
      query = query.gte("created_at", startDate);
    } else if (startDate !== "0" && endDate !== "0") {
      query = query.gte("created_at", startDate).lte("created_at", endDate);
    }
  }

  const { data, error } = await query;

  if (data) return data;
  else throw error;
}

export { FetchAllUserFromServer, FetchTokenPaymentData };
